import { useEffect, useState } from 'react';

export function useIsTouchDevice() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const hasTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    setIsTouch(hasTouch);
  }, []);

  return isTouch;
}
